import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Input, Button, Form, Select } from 'antd';
import { LEAD_STATUS } from '../../../constants/leadStatuses';
import { POPUP_TYPE } from '../../../constants/popupType';
import { changeLeadsStatusRequest } from '../../redux/actions/change_lead_status.actions';
import { addNoteRequest } from '../../redux/actions/add_note.actions';

const { TextArea } = Input;
const { Option } = Select;
const FormItem = Form.Item;

const cancellation_statuses = [
    { value: LEAD_STATUS.customerCancelledAlreadySoldBike, label: 'Customer Cancelled - Already Sold Bike' },
    { value: LEAD_STATUS.customerCancelledOfferedBetterPriceElsewhere, label: 'Customer Cancelled - Offered Better Price Elsewhere' },
    { value: LEAD_STATUS.customerWantsTooMuch, label: 'Customer Wants Too Much' },
    { value: LEAD_STATUS.customerChangedMind, label: 'Customer Changed Mind' },
    { value: LEAD_STATUS.triedToCallNoAnswer, label: 'Tried to Call - No Answer' },
    { value: LEAD_STATUS.triedToCallWrongNumber, label: 'Tried to Call - Wrong Number' },
    { value: LEAD_STATUS.collectionCancelled, label: 'Collection Cancelled' },
];

const cancellation_statuses_trade = [
    { value: LEAD_STATUS.collectionCancelledTrade, label: 'Collection Cancelled (Trade)' },
];

const mapStateToProps = (state) => {
    const root_id = state.Leads.Lead_profile.Lead_general.root_id;

    return {
        root_id
    };
};

export default connect(mapStateToProps, null)(class CancellCollectionModal extends Component {
    static propTypes = {
        status: PropTypes.string,
        dispatch: PropTypes.func.isRequired,
        root_id: PropTypes.string.isRequired,
        popup_type: PropTypes.string.isRequired,
        closeModal: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            cancellationStatus:
                this.props.popup_type === POPUP_TYPE.cancelCollectionTrade ? LEAD_STATUS.collectionCancelledTrade : (this.props.status || ''),
            cancellingReason: ''
        };

        this.handleSelect = this.handleSelect.bind(this);
        this.changeStatus = this.changeStatus.bind(this);
        this.isCollectionCancelled = this.isCollectionCancelled.bind(this);
    }

    isCollectionCancelled = (status) => 
        [LEAD_STATUS.collectionCancelled, LEAD_STATUS.collectionCancelledTrade].includes(status);

    handleSelect = (value) => this.setState({ cancellationStatus: value });
    
    changeStatus = () => {    
        const { dispatch, root_id } = this.props;
        const { cancellationStatus, cancellingReason } = this.state;
        let note;

        if (this.isCollectionCancelled(cancellationStatus)) {
            note = `CRM Cancellation Note: ${cancellingReason}`;
        } else {
            note = `CRM Cancellation Note: ${cancellation_statuses.find(({ value }) => value === cancellationStatus)?.label}`;
        }

        dispatch(changeLeadsStatusRequest(root_id, cancellationStatus, { reject_reason: note, onSuccess: () => dispatch(addNoteRequest(root_id, note)) }));
        this.props.closeModal();
    };

    render() {
        const statuses = this.props.popup_type === POPUP_TYPE.cancelCollectionTrade ? cancellation_statuses_trade : cancellation_statuses;
        const hasNoCancellingReason = this.isCollectionCancelled(this.state.cancellationStatus) && !this.state.cancellingReason;

        return (
            <div>
                <div>
                    Are you sure you want to cancel collection?
                </div>
                <Form>
                    <FormItem>
                        <Select
                            value={this.state.cancellationStatus}
                            onChange={this.handleSelect}
                        >
                            <Option value="" style={{ color: 'lightgray' }} disabled>Select Status</Option>
                            {statuses.map(({ value, label }) => (
                                <Option value={value} key={value}>{label}</Option>
                            ))}
                        </Select>
                    </FormItem>

                    {this.isCollectionCancelled(this.state.cancellationStatus) && (
                        <>
                            <div>
                                Reason <span style={{ color: 'red' }}>*</span>
                            </div>
                            <TextArea
                                style={{ marginBottom: 12 }}
                                defaultValue={this.state.cancellingReason}
                                onChange={(event) => {
                                    event.persist();

                                    this.setState((prevState) => ({
                                        ...prevState,
                                        cancellingReason: event.target.value,
                                    }));
                                }}
                            />
                        </>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={this.props.closeModal}>Cancel</Button>
                        <Button
                            disabled={!this.state.cancellationStatus || hasNoCancellingReason}
                            style={{ marginLeft: 10 }}
                            type="primary"
                            onClick={this.changeStatus}
                            >
                                Confirm
                        </Button>
                    </div>
                </Form>
            </div>
        );
    }
});
  


// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/CancellCollectionModal.js